import { render, staticRenderFns } from "./AdvancedTab.vue?vue&type=template&id=b77acae4&scoped=true"
import script from "./AdvancedTab.vue?vue&type=script&lang=ts"
export * from "./AdvancedTab.vue?vue&type=script&lang=ts"
import style0 from "./AdvancedTab.vue?vue&type=style&index=0&id=b77acae4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77acae4",
  null
  
)

export default component.exports